module.exports = __webpack_public_path__ + "media/images/hand-arm-and-noise-assessments-08e081ad36749c1dec1edaf1d8dabf75.jpg";